export default theme => ({
  checkbox: {
    color: "#67AAD1 !important"
  },
});
